import { SearchNormal1, User } from 'iconsax-react'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { weCheckPalette } from '@/utils/palette/weCheckPalette'

interface SearchResultsTopBarProps {
  value: string
  onSubmit: (value: string) => void
  onCantSpot: () => void
}

export const SearchResultsTopBar = ({
  value,
  onSubmit,
  onCantSpot,
}: SearchResultsTopBarProps) => {
  const { t } = useTranslation()
  const [draft, setDraft] = useState(value)

  useEffect(() => setDraft(value), [value])

  const handleSubmit = () => {
    const trimmed = draft.trim()
    if (!trimmed) return
    onSubmit(trimmed)
  }

  return (
    <div className="flex shrink-0 flex-col items-stretch gap-3 md:flex-row md:items-center md:justify-between md:gap-6">
      <div className="relative w-full md:max-w-[600px]">
        <span className="pointer-events-none absolute left-3 top-1/2 z-10 -translate-y-1/2">
          <User size="16" color={weCheckPalette.neutralColor60} />
        </span>
        <Input
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') handleSubmit()
          }}
          placeholder={t(
            'dashboard.runReport.searchResults.subjectNamePlaceholder',
          )}
          className="pl-9 pr-9"
        />
        <button
          type="button"
          onClick={handleSubmit}
          aria-label={t('dashboard.runReport.searchResults.search')}
          className="absolute right-2 top-1/2 z-10 flex h-7 w-7 -translate-y-1/2 items-center justify-center rounded-md hover:bg-baseColorHighlight"
        >
          <SearchNormal1 size="16" color={weCheckPalette.neutralColor60} />
        </button>
      </div>

      <Button variant="outline" onClick={onCantSpot} className="shrink-0">
        {t('dashboard.runReport.searchResults.cantSpot')}
      </Button>
    </div>
  )
}
